<script>
import {NestedTable} from "@core/components/common";
import dateRenderer from "@core/mixins/date-renderer";
import { BFormRadio } from 'bootstrap-vue'
import SearchOrAddSubstance from "@/views/product/components/product-card/SearchOrAddSubstance.vue";
import SearchOrAddSubstanceModal from "@/views/product/components/product-card/SearchOrAddSubstanceModal.vue";
import Button from "@core/components/common/Button.vue";
import Overlay from "@core/components/common/Overlay.vue";

export default {
    mixins: [dateRenderer],
    components: {Overlay, Button, SearchOrAddSubstanceModal, SearchOrAddSubstance, NestedTable, BFormRadio},
    props: {
        list: {
            type: Object,
        },
        isListCandidateList: {
            default: false,
            type: Boolean,
        },
        substances: {
            default() {
                return [];
            }
        },
        listId: {
            required: true
        },
        includedSubstances: {
            type: Array,
            default() {
                return [];
            }
        },
        excludedSubstances: {
            type: Array,
            default() {
                return [];
            }
        },
        skipNested: {
            default: true
        },
        autoExpandSubstances: {
            default: false
        },
        readOnly: {
            default: false
        },
        readOnlyForIncluded: {
            default: false
        },
        includedRadioDisabled: {
            default: false
        },
        includedRadioTitle: {
            default: null,
        }
    },
    data() {
        const fields = [
            {
                key: 'cas',
                label: this.$t('Component(SubstanceTable):column-cas'),
                search: true,
                matcher: this.filterCAS
            },
            {
                key: 'ec',
                label: this.$t('Component(SubstanceTable):column-ec'),
                search: true,
                matcher: this.filterEC
            },
            {
                key: 'inclusionDate',
                label: this.$t('Component(SubstanceTable):column-inclusion-date'),
                title: this.$t('Component(SubstanceTable):hover-column-inclusion-date')
            },
            {
                key: 'included',
                label: this.$t('Component(SubstanceTable):column-included'),
                title: this.$t('Component(SubstanceTable):hover-column-included'),
                search: true,
                searchType: 'YesNo',
                matcher: this.filterIncluded
            },
            {
                key: 'not_included',
                label: this.$t('Component(SubstanceTable):column-not-included'),
                title: this.$t('Component(SubstanceTable):hover-column-not-included'),
                search: true,
                searchType: 'YesNo',
                matcher: this.filterExcluded
            },
            {
                key: 'actions',
                label: this.$t('Component(SubstanceTable):column-undefined'),
                title: this.$t('Component(SubstanceTable):hover-column-undefined'),
                tdClass: 'pl-0 pr-0',
                search: true,
                searchType: 'YesNo',
                matcher: this.filterUndefined
            }
        ];

        if (!this.isListCandidateList) {
            fields[2] = {
                key: 'maxConcentration',
                label: this.$t('Component(CompositionSubstance):max-concentration'),
                title: this.$t('Component(CompositionSubstance):max-concentration')
            };
        }
        return {
            showLoading: false,
            parentSubstance: null,
            nameField: {
                key: 'title',
                label: this.$t('Component(SubstanceTable):column-title'),
                searchPlaceholder: this.$t('Component(SubstanceTable):placeholder-title'),
                search: true,
                matcher: this.filterTitle
            },
            fields: fields,
            autoExpandedItems: [],
            expandedItems: {},
            includedRadioTitleValue: this.includedRadioTitle ||  this.$t('Component(SubstanceTable):hover-column-included')
        };
    },
    methods: {
        filterIncluded(substance, value) {
            return this.isIncluded(substance) === value;
        },
        filterExcluded(substance, value) {
            return this.isExcluded(substance) === value;
        },
        filterUndefined(substance, value) {
            if (null === value) {
                return true;
            }

            if (value) {
                return !this.filterIncluded(substance, value) && !this.filterExcluded(substance, value);
            }

            return this.filterIncluded(substance, true) || this.filterExcluded(substance, true);
        },
        filterTitle(substance, value) {
            if (substance.hasOwnProperty('question')) {
                if (substance.question.toLowerCase().indexOf(value.toLowerCase()) >= 0) {
                    return true;
                }
            }
            return substance.title.toLowerCase().indexOf(value.toLowerCase()) >= 0;
        },
        filterEC(substance, value) {
            return substance.ec.indexOf(value) >= 0;
        },
        filterCAS(substance, value) {
            return substance.cas.indexOf(value) >= 0;
        },
        isIncluded(substance) {
            return this.includedSubstances.find(s => s.substance.id === substance.id) !== undefined;
        },

        isExcluded(substance) {
            return this.excludedSubstances.find(s => s.substance.id === substance.id) !== undefined;
        },

        includeSubstanceToAList(substance, parent) {
            this.showLoading = true;
            this.closeSearchModal();
            this.$emit('includeSubstanceToAList', substance, parent, this.list, () => {
                this.$emit('include', substance);
                this.$refs.table.reinitItems();
                this.$nextTick(() => this.showLoading = false);
            });
        },

        onItemCollapsed(topLevelSubstanceId, nestedSubstanceId) {
            if (!this.expandedItems.hasOwnProperty(topLevelSubstanceId)) {
                return;
            }
            const index = this.expandedItems[topLevelSubstanceId].findIndex(item => item === nestedSubstanceId);
            if (index >= 0) {
                this.expandedItems[topLevelSubstanceId].splice(index, 1);
            }
        },

        onTopLevelItemCollapsed(topLevelSubstanceId) {
            if (this.expandedItems.hasOwnProperty(topLevelSubstanceId)) {
                this.expandedItems[topLevelSubstanceId].splice(0);
            }
        },

        onItemExpanded(topLevelSubstanceId, nestedSubstanceId) {
            if (!this.expandedItems.hasOwnProperty(topLevelSubstanceId)) {
                this.expandedItems[topLevelSubstanceId] = [];
            }
            this.expandedItems[topLevelSubstanceId].push(nestedSubstanceId);
        },

        expandSelectedGroups(items, expandFunction) {
            if (!this.list.domain.allowNewSubstances()) {
                return;
            }

            items.forEach(item => {
                if (item.searchable && this.expandedItems.hasOwnProperty(item.id) && this.expandedItems[item.id].includes(item.id)) {
                    expandFunction(item, item.id);
                } else if (item.type === 'list-reference') {
                    if (!this.expandedItems.hasOwnProperty(item.id) || this.expandedItems[item.id].includes(item.id)) {
                        if (item.flatHierarchy) {
                            const index = item.flatHierarchy.findIndex(s => s.selected);
                            if (index > -1) {
                                expandFunction(item, item.id);
                            }
                        }
                    }
                }
            });
        },

        showSearchAndAdd(substance) {
            if (substance.searchable) {
                if (substance.children.length === 0) {
                    return true;
                }
                return this.$refs.table && this.$refs.table.isExpanded(substance);
            }

            return false;
        },

        openSearchModal(parentSubstance) {
            this.parentSubstance = parentSubstance;
            this.$refs.searchOrAddSubstanceModal.show();
        },

        closeSearchModal() {
            this.$refs.searchOrAddSubstanceModal.hide();
        },
        shouldBeRendered(substance) {
            return !(this.skipNested && substance.type === 'list-reference');
        },
        nameRenderer(item) {
            if (item.hasOwnProperty('question') && item.question) {
                return item.question;
            }
            return item.title.length > 64 ? item.title.substring(0, 64) + ' ...' : item.title
        }
    },
    watch: {
        includedSubstances() {
            if (this.$refs.table && this.includedSubstances.length > 0) {
                this.expandSelectedGroups(this.$refs.table.getItems(), this.$refs.table.expand);
            }
        }
    }
}
</script>

<template>
    <Overlay :show="showLoading">
        <SearchOrAddSubstanceModal
            ref="searchOrAddSubstanceModal"
            @include="(substance) => includeSubstanceToAList(substance, parentSubstance)"
        />
        <NestedTable
            ref="table"
            :name-field="nameField"
            :children="substances"
            :fields="fields"
            :active-fields="fields"
            :search="true"
            :short-name-renderer="nameRenderer"
            :render-item-determiner="shouldBeRendered"
            :auto-expand="autoExpandSubstances"
            @collapsed="onItemCollapsed"
            @collapsedAll="onTopLevelItemCollapsed"
            @expanded="onItemExpanded"
            @created="expandSelectedGroups"
            @reinitialized="expandSelectedGroups"
        >
            <template #last-row="data">
                <tr
                    v-if="!data.isSearchActive && list.domain.allowNewSubstances() && showSearchAndAdd(data.item)"
                    class="no-hover"
                >
                    <td :colspan="data.colCount" class="border-top-0 text-center">
                        <Button
                            class="btn-sm"
                            @click="openSearchModal(data.item)"
                        >
                            {{ $t('Component(Button):open-search-or-add-substance') }}
                        </Button>
                    </td>
                </tr>
            </template>

            <template #cell-title="data">
                <div>{{ data.item.title }}</div>
            </template>

            <template #cell-cas="data">
                <div class="substance-min-width">{{ data.item.cas }}</div>
            </template>

            <template #cell-ec="data">
                <div class="substance-min-width">{{ data.item.ec }}</div>
            </template>

            <template #cell-inclusionDate="data">
                <div :title="$t('Component(SubstanceTable):hover-column-inclusion-date')" class="substance-min-width">
                    {{ renderDate(data.item.inclusionDate) }}
                </div>
            </template>

            <template #cell-included="data">
                <div
                    v-if="data.item.selectable"
                    :title="includedRadioTitleValue"
                    class="text-center"
                >
                    <b-form-radio
                        :disabled="readOnly || includedRadioDisabled || (readOnlyForIncluded && data.item.selected)"
                        v-model="data.item.selected"
                        :name="'substance' + '_' + listId + '_' + data.item.id"
                        :value="true"
                        class="d-inline-block"
                        @change="$emit('include', data.item)"
                    />
                </div>
            </template>

            <template #cell-not_included="data">
                <div v-if="data.item.selectable" :title="$t('Component(SubstanceTable):hover-column-not-included')" class="text-center">
                    <b-form-radio
                        :disabled="readOnly || (readOnlyForIncluded && data.item.selected)"
                        v-model="data.item.selected"
                        :name="'substance' + '_' + listId + '_' + data.item.id"
                        :value="false"
                        class="d-inline-block"
                        @change="$emit('exclude', data.item)"
                    />
                </div>
            </template>

            <template #cell-actions="data">
                <div v-if="data.item.selectable" :title="$t('Component(SubstanceTable):hover-column-not-included')" class="text-center">
                    <b-form-radio
                        :disabled="readOnly || (readOnlyForIncluded && data.item.selected)"
                        v-model="data.item.selected"
                        :name="'substance' + '_' + listId + '_' + data.item.id"
                        :value="null"
                        class="d-inline-block"
                        @change="$emit('undefined', data.item)"
                    />
                </div>
            </template>
        </NestedTable>
        <div
            v-if="list.domain.allowNewSubstances()"
            class="text-center p-2"
        >
            <Button
                class="btn-sm"
                @click="openSearchModal(null)"
            >
                {{ $t('Component(Button):open-search-or-add-substance') }}
            </Button>
        </div>
    </Overlay>
</template>

<style scoped lang="scss">
td .substance-min-width {
    min-width: 115px;
}
</style>
